import { useEffect } from 'react';
import { Typography, Link, Stack } from '@mui/material';
/**
 * Generated from https://docs.google.com/document/d/1I3SqAPvbGl6dTKnxAPOsr3PKrDbYMW4Zr3MpzdOtIIo
 * Download as .html & adapted for React
 */
export const LpSignInConsent = (): JSX.Element => {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <Stack spacing={3}>
      <Typography variant="body1" component="p">
        At AgileEngine, LLC and its affiliated companies (collectively referred
        to as “AgileEngine”), we respect your privacy and are committed to
        protecting your personal information. This Privacy Notice explains how
        we collect, use, store, and protect your personal information, and
        outlines your rights related to that information. AgileEngine, LLC acts
        as the controller of your personal information. By checking “I agree to
        the personal information processing,” you agree to AgileEngine’s
        processing of your personal information in accordance with the rules
        outlined below. If you have any privacy-related questions or concerns,
        you can contact us at{' '}
        <Link href="mailto:policy@agileengine.com">policy@agileengine.com</Link>
        .
      </Typography>
      <Typography variant="body1" component="p">
        We may collect and process personal information such as your name,
        surname, email address, mobile phone number (if applicable), city and
        state, LinkedIn public profile information (if applicable), and your
        resume. In some cases, we may also process video recordings of you and
        your responses provided during the recruitment process. We process this
        data to conduct recruitment process, evaluate how well your profile
        aligns with AgileEngine’s business needs, to communicate the outcome of
        our review, to explore potential future collaboration, to provide access
        to AgileEngine’s websites (including LaunchPod), to support and
        communicate with you and other candidates, and to comply with applicable
        legal obligations.
      </Typography>
      <Typography variant="body1" component="p">
        Your personal information may be processed in various ways, including
        collection, storage, use, transmission (including cross-border
        transfers), and deletion. We may share your data with companies within
        the AgileEngine group and third-party partners under appropriate
        agreements, solely for the purposes outlined above.
      </Typography>
      <Typography variant="body1" component="p">
        We rely on your consent or, where applicable, other legal grounds such
        as our legitimate interests and contractual necessity to process your
        personal information. Your data will be retained only as long as
        necessary for the purposes for which it was collected.
      </Typography>
      <Typography variant="body1" component="p">
        You have the right to access, correct, or delete your personal
        information; restrict or object to its processing; withdraw your consent
        at any time (without affecting the lawfulness of prior processing); and
        request data portability. Depending on your residency status and
        applicable jurisdiction, you may also have other rights, such as the
        right to lodge a complaint with a relevant supervisory authority.{' '}
      </Typography>
      <Typography variant="body1" component="p">
        To exercise your right to be forgotten, you can delete your account and
        associated data using the Data Deletion option in your account settings.
        For all other data protection rights or to withdraw your consent, please
        contact us at policy@agileengine.com. Please note that AgileEngine may
        be able to retain your personal information even if the consent is
        withdrawn and the personal information is processed on the other legal
        basis.
      </Typography>
      <Typography variant="body1" component="p">
        You can learn more about how we process your personal information by
        accessing our{' '}
        <Link href="https://agileengine.com/privacy-policy/" target="_blank">
          Privacy Policy
        </Link>
        .
      </Typography>
    </Stack>
  );
};
